import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component, Fragment } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataContact } from '../../data/DataContact';
import { DataOrigineContact } from '../../data/DataOrigineContact';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { FicheContactTransfertPropriete } from '../Fiche/FicheContactTransfertPropriete';
import { FicheDenonciation } from '../Fiche/FicheDenonciation';

export class DetailsListOrigineContact extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListOrigineContactWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListOrigineContactWithPerimetre extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        idContact: undefined,
        perimetre: {}
    };

    static defaultState = {
        items: [],
        itemsSelectionnes: [],
        afficherPanelTransfertPropriete: false,
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListOrigineContactWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "creerLe";
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des données en cours...");

        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataOrigineContact._chargementOriginesContacts(this._filtres, tri, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let newItems = [];
                let listeOriginesContacts = responseFetch.reponseAPIobjet;

                if (this.state.pageIndex === 1) {
                    newItems = listeOriginesContacts;
                }
                else {
                    newItems = [...this.state.items];
                    newItems = newItems.concat(listeOriginesContacts);
                }

                const state = { items: newItems };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ items: [] });
            }
            dismissMessage(messageId);
        });
    };

    _chargementDroits = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des droits en cours...");

        DataContact._chargementListeDesDroitsFicheContact().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let droits = responseFetch.reponseAPIobjet;
                let peutAffecterA = droits[10];
                let peutRetirerA = droits[11];
                const state = { peutAffecterA, peutRetirerA };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else fetchMessages(responseFetch);
        });
        dismissMessage(messageId);

    };

    _getColumns = () => {
        return [
            {
                key: "nomCommercial",
                minWidth: 75,
                maxWidth: 150,
                name: "Opération",
            },
            {
                key: "nom",
                minWidth: 100,
                maxWidth: 150,
                name: "Nom",
            },
            {
                key: "prenom",
                minWidth: 100,
                maxWidth: 150,
                name: "Prénom",
            },
            {
                key: "creerLe",
                name: "Créé le",
            },
            {
                className: "ms-hiddenLgDown",
                headerClassName: "ms-hiddenLgDown",
                key: "proprietaireEnCours",
                minWidth: 75,
                maxWidth: 200,
                name: "Propriétaire",
            },
            {   //MG: 2379
                key: "email",
                minWidth: 130,
                maxWidth: 150,
                name: "Mail lead",
            },
            {   //MG: 2379
                key: "zoneGeographique",
                minWidth: 100,
                maxWidth: 150,
                name: "Zone de recherche",
            },
            {
                className: "ms-hiddenLgDown",
                headerClassName: "ms-hiddenLgDown",
                key: "webtag",
                minWidth: 260,
                maxWidth: 260,
                name: "Webtag",
            },
            {
                className: "ms-hiddenMdDown",
                headerClassName: "ms-hiddenMdDown",
                key: "url",
                minWidth: 100,
                maxWidth: 100,
                name: "URL",
            },
            {
                key: "utm_medium",
                minWidth: 100,
                maxWidth: 100,
                name: "Medium UTM",
            },
            {
                key: "utm_source",
                minWidth: 100,
                maxWidth: 150,
                name: "Source UTM",
            },
            {
                key: "utm_campaign",
                minWidth: 75,
                maxWidth: 75,
                name: "Campagne UTM",
            },
            {
                className: "ms-hiddenXlDown",
                headerClassName: "ms-hiddenXlDown",
                key: "utm_term",
                minWidth: 75,
                maxWidth: 75,
                name: "Mots-clés UTM",
            },
            {
                className: "ms-hiddenXlDown",
                headerClassName: "ms-hiddenXlDown",
                key: "utm_content",
                minWidth: 75,
                maxWidth: 75,
                name: "Contenu UTM",
            },
        ];
    };

    _getFiltres = () => {
        const { idContact } = this.props;
        let filtres = {};
        if (!!idContact) filtres.idContact = idContact;
        return filtres;
    };

    _getItems = () => {

        const { itemsSelectionnes, peutAffecterA, peutRetirerA } = this.state;

        let items = [];

        if (peutAffecterA)
            items.push({
                disabled: itemsSelectionnes.length === 0,
                iconProps: { iconName: "PageEdit" },
                key: "link",
                name: "Poser des dénonciations",
                onClick: this._togglePanel("Denonciation", true, { estAffectation: true })
            });

        if (peutRetirerA)
            items.push({
                disabled: itemsSelectionnes.length === 0,
                iconProps: { iconName: "PageRemove" },
                key: "unlink",
                name: "Enlever des dénonciations",
                onClick: this._togglePanel("Denonciation", true, { estAffectation: false })
            });


        if (peutAffecterA)
            items.push({
                disabled: itemsSelectionnes.length === 0,
                key: "transfert",
                name: "Transfert de propriété",
                iconProps: { iconName: "Switch" },
                onClick: this._togglePanel("TransfertPropriete", true)
            });

        return items;

    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this._columns = this._getColumns();
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onCounterClick = () => {
        this.setState(prevState => ({
            facteurNbreEnregistrement: prevState.facteurNbreEnregistrement > 0 ? -1 : DetailsListOrigineContactWithPerimetre.defaultState.facteurNbreEnregistrement,
            pageIndex: 1
        }), this._chargementDonnees
        );
    };

    _onScroll = () => {
        const { facteurNbreEnregistrement } = this.state;
        if (facteurNbreEnregistrement > 0)
            this.setState(
                prevState => ({ pageIndex: prevState.pageIndex + 1 }),
                this._chargementDonnees
            );
    };

    _togglePanel = (nomPanel, isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
        this._chargementDroits();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { afficherPanelDenonciation, afficherPanelTransfertPropriete, estAffectation, facteurNbreEnregistrement, items, itemsSelectionnes } = this.state;

        return <Fragment>

            <EUIDetailsList
                columns={this._columns}
                getKey={item => `${item.idOrigineContact};#${item.idContact};#${item.idSouhait}`}
                isLazyLoadingEnabled={facteurNbreEnregistrement > 0}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onCounterClick={this._onCounterClick}
                onScroll={this._onScroll}
                onSearch={this._onSearch}
                onSelectionChanged={items => this.setState({ itemsSelectionnes: items })}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <FicheContactTransfertPropriete
                isOpen={afficherPanelTransfertPropriete}
                listeIdContacts={itemsSelectionnes.map(contact => contact.idContact)}
                onDismiss={this._togglePanel("TransfertPropriete", false)}
                onSave={this._togglePanel("TransfertPropriete", false, {}, this._chargementDonnees)}
            />

            <FicheDenonciation
                estAffectation={estAffectation}
                isOpen={afficherPanelDenonciation}
                listeIdContacts={itemsSelectionnes.map(contact => contact.idContact)}
                onDismiss={this._togglePanel("Denonciation", false)}
                onSave={this._togglePanel("Denonciation", false, {}, this._chargementDonnees)}
            />

        </Fragment>;

    };

};